import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const DriverPayoutDetail = () => {
  return (
    <>
      <section className="driverPayoutDetail py-2 position-relative">
        <Container>
          <Row>
            <Col lg="6" className="my-2">
              <h4 className="m-0 fw-sbold themeBlue pb-2">Booking Details:</h4>
              <div className="cardCstm p-3 bg-white rounded">
                <ul className="list-unstyled ps-0 mb-0">
                  <li className="py-2 d-flex align-items-start gap-10">
                    <span className="text-muted fw-sbold w-50">Booking ID:</span>
                    <span className="fw-sbold text-danger">UH5d7DW</span>
                  </li>
                  <li className="py-2 d-flex align-items-start gap-10">
                    <span className="text-muted fw-sbold w-50">Pickup Location:</span>
                    <span className="fw-sbold text-danger w-50">
                      2464 Royal Ln. Mesa, New Jersey 45463
                    </span>
                  </li>
                  <li className="py-2 d-flex align-items-start gap-10">
                    <span className="text-muted fw-sbold w-50">Drop Off Location:</span>
                    <span className="fw-sbold text-danger w-50">
                      2464 Royal Ln. Mesa, New Jersey 45463
                    </span>
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg="6" className="my-2">
              <h4 className="m-0 fw-sbold themeBlue pb-2">Driver Details: </h4>
              <div className="cardCstm p-3 bg-white rounded">
                <ul className="list-unstyled ps-0 mb-0">
                  <li className="py-2 d-flex align-items-start gap-10">
                    <span className="text-muted fw-sbold w-50">Driver Name:</span>
                    <span className="fw-sbold text-danger">Gladys</span>
                  </li>
                  <li className="py-2 d-flex align-items-start gap-10">
                    <span className="text-muted fw-sbold w-50">Driver Mobile Number:</span>
                    <span className="fw-sbold text-danger w-50">+447700960063</span>
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg="6" className="my-2">
              <h4 className="m-0 fw-sbold themeBlue pb-2">Bank Details: </h4>
              <div className="cardCstm p-3 bg-white rounded">
                <ul className="list-unstyled ps-0 mb-0">
                  <li className="py-2 d-flex align-items-start gap-10">
                    <span className="text-muted fw-sbold w-50">Bank Name:</span>
                    <span className="fw-sbold text-danger">AXIS Bank</span>
                  </li>
                  <li className="py-2 d-flex align-items-start gap-10">
                    <span className="text-muted fw-sbold w-50">Routing number:</span>
                    <span className="fw-sbold text-danger w-50">+25985741365</span>
                  </li>
                  <li className="py-2 d-flex align-items-start gap-10">
                    <span className="text-muted fw-sbold w-50">Account number:</span>
                    <span className="fw-sbold text-danger w-50">9876 5412 5795 3455</span>
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg="6" className="my-2">
              <h4 className="m-0 fw-sbold themeBlue pb-2">Payment Details: </h4>
              <div className="cardCstm p-3 bg-white rounded">
                <ul className="list-unstyled ps-0 mb-0">
                  <li className="py-2 d-flex align-items-start gap-10">
                    <span className="text-muted fw-sbold w-50">Total Fair:</span>
                    <span className="fw-sbold text-danger">$50.00</span>
                  </li>
                  <li className="py-2 d-flex align-items-start gap-10">
                    <span className="text-muted fw-sbold w-50">Driver Payment:</span>
                    <span className="fw-sbold text-danger w-50">$40.00</span>
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default DriverPayoutDetail;
